import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
    const { user, loading, bootstrapped } = useAuth();

    if (!bootstrapped || loading) return null;

    return user ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
